import { SalaryPriceTeacher } from '@/plugins/api'
import alert from '@/plugins/alert'
import loadingCount from '@/plugins/loadingCount'
import { chunk } from 'lodash'
export default {
  namespaced: true,
  state: {
    priceStudents: [],
    listStudentError: [],
    loading: false
  },
  actions: {
    async createTuitionFeePriceStudent(_, { rootPrice, students, headFee }) {
      try {
        let count = 0
        let prices = {}
        const delay = ms =>
          new Promise(
            res => setTimeout(res, ms),
            () => {}
          )
        let arrStudents = chunk(students, 10)
        for await (const studentCurt of arrStudents) {
          for await (const student of studentCurt) {
            loadingCount.count(count)
            prices[`${student.code}`] = {
              amount: student.price,
              type: student.type.includes('%') ? 'percentage' : 'fixed',
              notes: student.notes
            }
            loadingCount.count(count)
            count++
            await delay(100)
          }
          let params = {
            rootPriceId: rootPrice._id,
            headFeeId: headFee.id,
            periodId: rootPrice.period._id,
            prices: prices
          }
          prices = {}
          await SalaryPriceTeacher.addPack(params)
        }
        alert.updateSuccess('giáo viên')
      } catch (err) {
        let strError = err.replace('Giáo viên không tồn tại trên hệ thống ', '')
        let error = strError.split(',')
        let mesError = ''
        for (const err of error) {
          mesError += `Điện thoại giáo viên ${err} không tồn tại.<br/>`
        }
        alert.addPeriodError({
          title: 'Lỗi dữ liệu',
          description: mesError
        })
      }
    },
    async removePriceStudents(_, rootPrice) {
      try {
        await SalaryPriceTeacher.removePriceTeacher(rootPrice.id)
      } catch (error) {
        alert.addError(error)
      }
    },
    async fetchPriceStudents(_, rootPrice) {
      let priceStudents = []
      let params = {
        rootPrice: rootPrice.id
      }
      let res = await SalaryPriceTeacher.search(params)
      res.forEach((item, index) => {
        const { price, type, notes } = item
        priceStudents.push({ ...item.teacher, index: index + 1, price, type, notes })
      })
      return priceStudents
    }
  },
  mutations: {
    setHeadFees(state, headFees) {
      state.headFees = headFees
    },
    setListStudentError(state, studentError) {
      state.listStudentError = studentError
    }
  },
  getters: {
    priceStudents: state => state.priceStudents
  }
}
